import { NgModule } from '@angular/core';
import { LoggerService } from './services/logger.service';

@NgModule({
	imports: [],
	exports: [],
	declarations: [],
	providers: [LoggerService]
})
export class LoggerModule { }